module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also By George Bellairs")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Littlejohn on Leave")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Four Unfaithful Servants")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death of a Busybody")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Dead Shall be Raised")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Stops the Frolic")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Murder of a Quack")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("He’d Rather be Dead")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Calamity at Harwood")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in the Night Watches")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Crime at Halfpenny Bridge")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Case of the Scared Rabbits")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death on the Last Train")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Case of the Seven Whistlers")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Case of the Famished Parson")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Outrage on Gallows Hill")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Case of the Demented Spiv")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Brings in the New Year")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Dead March for Penelope Blow")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in Dark Glasses")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Crime in Lepers’ Hollow")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("A Knife for Harry Dodd")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Half-Mast for the Deemster")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Cursing Stones Murder")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in Room Five")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Treads Softly")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Drops the Pilot")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in High Provence")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Sends for the Doctor")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Corpse at the Carnival")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Murder Makes Mistakes")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Bones in the Wilderness")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Toll the Bell for Murder")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Corpses in Enderby")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in the Fearful Night")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in Despair")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death of a Tin God")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Body in the Dumb River")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Before Breakfast")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Tormentors")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in the Wasteland")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Surfeit of Suspects")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death of a Shadow")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death Spins the Wheel")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Intruder in the Dark")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Strangers Among the Dead")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Death in Desolation")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Single Ticket to Death")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Fatal Alibi")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Murder Gone Mad")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Tycoon’s Deathbed")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Night They Killed Joss Varran")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Pomeroy, Deceased")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Murder Adrift")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Devious Murder")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Fear Round About")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Close All Roads to Sospel")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Downhill Ride of Leeman Popple")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("An Old Man Dies")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752b09a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-george-bellairs.vue
// module id = 66
// module chunks = 0